<template>
	<div class='add-species-block'>

		<span>Порода</span>
		<custom-p-select
			v-model='selectedSpecies'
			:options='info_species_ext'
			dataKey='keyId'
			@input='getShortNameList'
			class='species-select'
		/>

		<span>Сокращенное название</span>
		<custom-p-select
			v-model='selectedNameShort'
			:options='shortNameList'
			:optionLabel='null'
			:dataKey='null'
			class='short-name-species-select'
		/>

		<div class='btn-block'>
			<button @click='save'>Сохранить</button>
			<button @click='close'>Закрыть</button>
		</div>

	</div>
</template>

<script>
	import processJSON from '@/lib/processJSON';
	const GET_SPECIES_NAME_SHORT = process.env.VUE_APP_ROOT_API + 'get_species_name_short.php';

	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'RecountTreeListAddBlockAddTaxSpecies',
		
		data: () => ({
			speciesList: [],
			shortNameList: [],

			selectedSpecies: null,
			selectedNameShort: null,
		}),
		computed: {
			info_species_ext() {
				return this.info_species.map(species => {
					return {
						...species,
						keyId: species.id + species.name
					};
				})
			},

			...mapState('selectedLpo', {
				taxData: state => state['taxData']
			}),

			...mapState({
				info_species: state => state.catalogs['info_species']
			})
		},
		watch: {

		},
		methods: {

			close() {

				this.$emit('close');
			},

			getShortNameList(species) {

				if (!species || !species.id) {
					this.selectedNameShort = null;
					this.shortNameList = [];
					return;
				}

	      const form = new FormData();
	      form.append('species_id', species.id);

	      fetch(GET_SPECIES_NAME_SHORT, {
	        credentials: 'include',
	        method: 'post',
	        body: form
	      })
	      .then(res => res.json())
	      .then(res => {
	        this.shortNameList = res.map(item => item.name);
	      })
	      .catch(err => console.log(err));
			},


			save() {
				console.log(this.taxData);
				// return;

				if (!this.selectedSpecies || !this.selectedSpecies.id) {
					console.log('no species');
					return;
				}

				if (!this.taxData.length || (!this.taxData[0].layer_id) ) {
					console.log('no layers');
					return;
				}

				const layer = this.taxData[0];

				const json_obj = [
	        {
	          'i': {
	            'tab': [
	              {
	                'tab_name': 'info_tax_layer_species',
	                'f_v': {
	                  'parent_id': layer.layer_id,
	                  'species_id': this.selectedSpecies.id,
	                  'name': this.selectedSpecies.name,
	                  'name_short': this.selectedNameShort,
	                  'is_extra': true,
	                }
	              }
	            ]
	          }
	        }
	      ];
	      const json_str = JSON.stringify(json_obj);
	      // console.log(json_str);
	      // return;

      	processJSON(json_str).then(res => {
      		this.updateSpeciesList();
					this.$store.dispatch('recount/fetchSpeciesList');
      		this.close();
      	});
			},

			...mapActions('selectedLpo/recount', [
				'updateSpeciesList'
			]),

			...mapActions([
				'loadCatalogs'
			])

		},

		created() {
			const catalogs = [ 'info_species' ];
			this.loadCatalogs(catalogs);
		}
	};
</script>



<style scoped>


	.add-species-block {

		background-color: white;
		border: 1px solid black;
		padding: 20px;
		position: absolute;
		top: 0;
		z-index: 10;
	}

	.species-select {
		margin-bottom: 10px;
	}

	.short-name-species-select {
		margin-bottom: 10px;
	}

	.btn-block button:first-child {
		margin-right: 10px;
	}
</style>